import React from "react";

interface Props {}

const CheckIcon: React.FC<Props> = ({}) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7474 0.329986C17.958 0.540916 18.0764 0.826862 18.0764 1.12499C18.0764 1.42311 17.958 1.70904 17.7474 1.91999L6.87241 12.795C6.66147 13.0056 6.37554 13.1239 6.07741 13.1239C5.77929 13.1239 5.49334 13.0056 5.28241 12.795L0.407413 7.91999C0.208693 7.70672 0.100513 7.42466 0.105643 7.13319C0.110788 6.84174 0.228853 6.56367 0.434983 6.35754C0.641098 6.15143 0.919183 6.03336 1.21063 6.02822C1.50208 6.02307 1.78414 6.13127 1.99741 6.32999L6.07741 10.41L16.1574 0.329986C16.3683 0.119311 16.6542 0.000976562 16.9524 0.000976562C17.2505 0.000976562 17.5365 0.119311 17.7474 0.329986Z"
        fill="#2AD966"
      />
    </svg>
  );
};

export default CheckIcon;
